import { render, staticRenderFns } from "./ChartingMobileFeed.vue?vue&type=template&id=484b2aa2&scoped=true&"
import script from "./ChartingMobileFeed.vue?vue&type=script&lang=js&"
export * from "./ChartingMobileFeed.vue?vue&type=script&lang=js&"
import style0 from "./ChartingMobileFeed.vue?vue&type=style&index=0&id=484b2aa2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484b2aa2",
  null
  
)

export default component.exports